import { HelperResult, ResumeFile } from '@openclassrooms/sdk-web';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const {
  useGet: useGetResumeFile,
  useUpdate: useUpdateResumeFile,
  useDelete: useDeleteResumeFile,
} = getCRUDHooks({
  entityName: 'resumeFile',
  get: ({ userId }: { userId: number }): HelperResult<ResumeFile> =>
    clientApi.getOCClient().helpers.user.users.id(userId).resumeFile.get(),
  update: (
    values: { filename: string; contents: string | ArrayBuffer | null },
    { userId, context }: { userId: number; context: string }
  ): HelperResult<ResumeFile> =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .resumeFile.update('', values, false)
      .setHeader('X-Request-Context', context)
      .execute(),
  remove: ({ userId }: { userId: number }) =>
    clientApi.getOCClient().helpers.user.users.id(userId).resumeFile.delete(),
});

export { useGetResumeFile, useUpdateResumeFile, useDeleteResumeFile };
